//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.PdmCopyOrEditOperationBuilder.js";
let d=[[[0,"DependentFilesToCopyOption",1,0]],[[["parts","nErrorMsgs","errorMsgs"],"AddSelectedParts",{},1,0],[["doUpdate","nObjects","copyOperationObjects"],"CreateOrUpdateSaveAsNewItemTypeOperationObjects",{},1,0],[["itemType"],"SetItemType",{},1,0],[["ecnCliSpec"],"SetChangeNotice",{},1,0]],[]];
SPLM.PDM.SaveAsNewItemTypeBuilder = class extends SPLM.PDM.PdmCopyOrEditOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.SaveAsNewItemTypeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;